// AI Model Configurations
export const AI_MODELS = {
    GPT_3_5_TURBO: {
        name: 'GPT-3.5 Turbo',
        model: 'gpt-3.5-turbo',
        apiUrl: 'https://api.openai.com/v1/chat/completions',
        maxTokens: 4096,
        temperature: 0.7,
        topP: 0.8,
        description: 'Fast, cost-effective model for most tasks',
        useCase: 'General content generation, analysis, creative tasks',
        costPer1KTokens: 0.002 // $0.002 per 1K tokens
    },
    GPT_4: {
        name: 'GPT-4',
        model: 'gpt-4',
        apiUrl: 'https://api.openai.com/v1/chat/completions',
        maxTokens: 8192,
        temperature: 0.7,
        topP: 0.8,
        description: 'Advanced model with superior reasoning',
        useCase: 'Complex analysis, detailed content, reasoning tasks',
        costPer1KTokens: 0.03 // $0.03 per 1K tokens
    },
    GPT_4_TURBO: {
        name: 'GPT-4 Turbo',
        model: 'gpt-4-turbo-preview',
        apiUrl: 'https://api.openai.com/v1/chat/completions',
        maxTokens: 128000,
        temperature: 0.7,
        topP: 0.8,
        description: 'Latest GPT-4 with extended context',
        useCase: 'Long-form content, complex analysis, large context',
        costPer1KTokens: 0.01 // $0.01 per 1K tokens
    }
};

export const DEFAULT_MODEL = AI_MODELS.GPT_3_5_TURBO;

// Model selection utilities
export const getModelConfig = (modelName) => {
    const modelKey = Object.keys(AI_MODELS).find(key =>
        AI_MODELS[key].model === modelName || AI_MODELS[key].name === modelName
    );
    return modelKey ? AI_MODELS[modelKey] : DEFAULT_MODEL;
};

export const getModelOptions = () => {
    return Object.entries(AI_MODELS).map(([key, model]) => ({
        value: model.model,
        label: model.name,
        description: model.description,
        cost: model.costPer1KTokens
    }));
};

// Model-specific configurations optimized for cost and performance
export const MODEL_CONFIGS = {
    GUEST_ANALYSIS: {
        model: AI_MODELS.GPT_3_5_TURBO.model,
        temperature: 0.3, // More deterministic for scoring
        max_tokens: 1000
    },
    CONTENT_GENERATION: {
        model: AI_MODELS.GPT_3_5_TURBO.model,
        temperature: 0.7, // More creative for content
        max_tokens: 2000
    },
    OUTREACH_EMAILS: {
        model: AI_MODELS.GPT_3_5_TURBO.model,
        temperature: 0.5, // Balanced creativity and consistency
        max_tokens: 1500
    },
    RESEARCH: {
        model: AI_MODELS.GPT_3_5_TURBO.model,
        temperature: 0.2, // More factual for research
        max_tokens: 2000
    },
    PLANNING: {
        model: AI_MODELS.GPT_4_TURBO.model,
        temperature: 0.7, // Creative but reasoned
        max_tokens: 4096
    }
};